export default __webpack_public_path__ + "static/media/red-shift.0cd389bf.svg";